<template>
   <transition>
      <div class="default">
        <h1>Galerie</h1>
        <div v-for="item in pageObjectForSlug(this.$route.name)"  >
          <div v-if="!item.children.length==0" class="images masonry" v-for="(value,key,index) in pageObjectForSlug(item.slug)" >
            <ul>
             <li v-for="val in value.children" >
                <router-link :to="{ path:item.slug+'/'+val.slug }"> 
               <!--  <h2>{{ val.title }}</h2> -->
                <img v-lazy="val.image">
               <!--  <span>{{ val.year }}</span> -->
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </transition>
</template>


<script>
import { PageObject } from './../util/pageobject.js' 
const o = new PageObject() 

export default {
  name: 'projectoverview',
   data () {
    return {
      localStorage: this.$store.state.jsonData
    }
  },
  methods:{
    pageObjectForSlug(sulgname){
      let res = o.pageObjectForSlugFromArray(sulgname,this.localStorage)
      return res;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ProjectOverview.vue